/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Notifications récentes dans l\'application',
    titleMeta: 'Affichage des notifications récentes dans l\'application CamAPS FX',
    descriptionMeta: 'Voici le texte des récentes notifications intégrées à l\'application concernant les mises à jour de l\'application, les avis de sécurité, les mises à jour du manuel d\'utilisation',
    keywords: 'Notifications' ,
    localeMeta: 'fr_fr',

    heading: 'Notifications récentes dans l\'application',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Mise à jour de l\'application Android (YpsoPump only) 28/10/2026',
    body_132:'Cher utilisateur de CamAPS FX, une nouvelle version de l\'application 1.4(195) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Mise à jour requise (YpsoPump uniquement) 20/10/2026',
    body_130:'Mise à jour requise ! Cette version de CamAPS FX peut planter et redémarrer plus fréquemment. Veuillez effectuer la mise à jour vers la dernière version DÈS MAINTENANT via le Google Play Store. La version 1.4(190) de l\'application sera abandonnée le 20/11/2026. Après cette date, « Auto mode » ne sera plus disponible tant que l\'application n\'aura pas été mise à jour. L\'administration d\'insuline via votre pompe se poursuivra.',

    header_129:'',
    body_129:'',

    header_128:'Mise à jour du manuel d\'utilisateur (YpsoPump uniquement) 15/10/2026',
    body_128:'Une version actualisée du manuel d\'utilisateur est désormais disponible. Vous pouvez y accéder depuis le menu principal de CamAPS FX en sélectionnant Aide après avoir effectué la mise à jour vers la dernière version de l\'application.',

    header_127:'Mise à jour de l\'application iOS (YpsoPump only) 08/10/2026',
    body_127:'Cher utilisateur de CamAPS FX, une NOUVELLE VERSION de l\'application 1.4(196) sera disponible dans les prochains jours. DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES DE CamAPS FX dans l\'App Store pour choisir votre moment de mise à jour préféré. Si vous avez des questions, veuillez contacter le service client de mylife-Diabetescare.',

    header_126:'Mise à jour de l\'application Android (YpsoPump only) 02/10/2026',
    body_126:'Cher utilisateur de CamAPS FX, une nouvelle version de l\'application 1.4(194) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'Mise à jour de l\'application iOS (YpsoPump only) 28/09/2026',
    body_122:'Cher utilisateur de CamAPS FX, une NOUVELLE VERSION de l\'application 1.4(196) sera disponible dans les prochains jours. DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES DE CamAPS FX dans l\'App Store pour choisir votre moment de mise à jour préféré. Si vous avez des questions, veuillez contacter le service client de mylife-Diabetescare.',

    header_121:'Sortie Apple iOS 27 11/09/2026',
    body_121:'Apple va bientôt lancer iOS 27. Afin de garantir une utilisation ininterrompue de l\'application CamAPS FX, veuillez vérifier la compatibilité de votre smartphone et de votre système d\'exploitation sur le site du fabricant du capteur AVANT de mettre à jour votre iPhone vers iOS 27. Les mises à jour automatiques peuvent être ACTIVÉES par défaut dans les paramètres de votre téléphone; veuillez envisager de les DÉSACTIVER.',

    header_120:'',
    body_120:'',

    header_119:'Mise à jour du manuel d\'utilisateur (YpsoPump uniquement) 10/09/2026',
    body_119:'Une version actualisée du manuel d\'utilisateur est désormais disponible. Vous pouvez y accéder depuis le menu principal de CamAPS FX en sélectionnant Aide après avoir effectué la mise à jour vers la dernière version de l\'application.',

    header_118:'Mise à jour de l\'application Android (YpsoPump only) 07/09/2026',
    body_118:'Cher utilisateur de CamAPS FX, une nouvelle version de l\'application 1.4(193) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'Message d\'Abbott 24/08/2026',
    body_115:'Important : le capteur FreeStyle Libre 3 Plus remplace le capteur FreeStyle Libre 3 qui ne sera plus commercialisé à la date du 30/11/2026. Veuillez-vous rapprocher de votre médecin pour mettre à jour votre prescription.',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Désactivation des versions Android inférieures à 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Cher utilisateur de CamAPS FX, pour des raisons de cybersécurité, les versions INFÉRIEURES à 1.4(192) seront ARRÊTÉES le 31/08/2026. Veuillez vous assurer que votre application est MISE À JOUR vers la version 1.4(192) avant cette date. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Version Android OS 17 24/06/2026',
    body_109:'Android publiera prochainement OS 17. Afin de garantir une utilisation ininterrompue de l\'application CamAPS FX, veuillez vérifier la compatibilité de votre smartphone et de votre système d\'exploitation sur le site du fabricant du capteur AVANT de mettre à jour votre appareil Android vers OS 17. Les mises à jour automatiques peuvent être ACTIVÉES par défaut dans les paramètres de votre téléphone; veuillez les DÉSACTIVER.',

    header_108:'',
    body_108:'',

    header_107:'',
    body_107:'',

    header_106:'Mise à jour du manuel d\'utilisateur (YpsoPump uniquement) 22/06/2026',
    body_106:'Une version actualisée du manuel d\'utilisateur est désormais disponible. Vous pouvez y accéder depuis le menu principal de CamAPS FX en sélectionnant Aide.',

    header_105:'Dexcom G7 est disponible (YpsoPump uniquement; Dexcom G6 uniquement) 19/06/2026',
    body_105:'CH uniquement - Rappel : l\'intégration du système CGM Dexcom G7 est désormais disponible ! Les utilisateurs passant du Dexcom G6 trouveront des instructions détaillées sur la marche à suivre sur notre site web : www.mylife-diabetescare.com.',

    header_104:'',
    body_104:'',

    header_103:'Mise à jour de l\'application Android (YpsoPump only) 12/06/2026',
    body_103:'Pour FR uniquement - Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application 1.4(192) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'Dexcom G7 est disponible (YpsoPump uniquement; Android uniquement) 09/06/2026',
    body_101:'Pour CH uniquement - L\'intégration du système CGM Dexcom G7 est désormais disponible ! Les utilisateurs passant du Dexcom G6 peuvent trouver plus d\'informations ainsi qu\'un aperçu des systèmes CGM compatibles sur notre site web : www.mylife-diabetescare.com.',

    header_100:'Mise à jour de l\'application Android (YpsoPump uniquement) 05/06/2026',
    body_100:'Pour CH uniquement - Cher utilisateur de CamAPS FX, une nouvelle version de CamAPS FX, 1.4(192), sera disponible dans les prochains jours. Pour choisir quand effectuer la mise à jour, veuillez DÉSACTIVER LES MISES À JOUR AUTOMATIQUES dans le Play Store. Les utilisateurs de systèmes d\'exploitation INFÉRIEURS à OS 13 ne pourront PAS METTRE À JOUR CamAPS FX vers cette version. Une version actualisée du manuel d\'utilisateur est désormais disponible. Pour toute question, veuillez contacter le service client mylife-Diabetescare.',

    header_99:'Dexcom G7 est disponible (YpsoPump uniquement; iOS uniquement) 02/06/2026',
    body_99:'Pour CH uniquement - L\'intégration du système CGM Dexcom G7 est désormais disponible ! Les utilisateurs passant du Dexcom G6 peuvent trouver plus d\'informations ainsi qu\'un aperçu des systèmes CGM compatibles sur notre site web : www.mylife-diabetescare.com.',

    header_98:'Arrêt des anciens systèmes d\'exploitation 22/05/2026',
    body_98:'Une prochaine mise à jour de l\'application CamAPS FX est à venir, veuillez noter qu\'elle ne sera ensuite pris en charge qu\'UNIQUEMENT sur des téléphones compatibles avec les capteurs exécutant les systèmes d\'exploitation suivants : Android OS 13 et versions ultérieures, et Apple iOS 18 et versions ultérieures. Après la publication de cette mise à jour, les utilisateurs de systèmes d\'exploitation INFÉRIEURS à Android OS 13 ou Apple iOS 18 ne pourront PAS METTRE À JOUR ni RÉINSTALLER CamAPS FX.',

    header_97:'Mise à jour de l\'application iOS 22/05/2026',
    body_97:'Cher utilisateur de CamAPS FX, une nouvelle version de CamAPS FX, 1.4(195), sera disponible dans les prochains jours. Pour choisir quand effectuer la mise à jour, veuillez DÉSACTIVER LES MISES À JOUR AUTOMATIQUES dans l\'App Store. Les utilisateurs de systèmes d\'exploitation INFÉRIEURS à iOS 18 ne pourront PAS METTRE À JOUR CamAPS FX vers cette version. Une version actualisée du manuel d\'utilisateur est désormais disponible. Pour toute question, veuillez contacter le service client mylife-Diabetescare.',

    header_96:'Arrêt des anciens systèmes d\'exploitation 11/05/2026',
    body_96:'Pour CH uniquement - Une prochaine mise à jour de l\'application CamAPS FX est à venir, veuillez noter qu\'elle ne sera ensuite pris en charge qu\'UNIQUEMENT sur des téléphones compatibles avec les capteurs exécutant les systèmes d\'exploitation suivants : Android OS 13 et versions ultérieures, et Apple iOS 18 et versions ultérieures. Après la publication de cette mise à jour, les utilisateurs de systèmes d\'exploitation INFÉRIEURS à Android OS 13 ou Apple iOS 18 ne pourront PAS METTRE À JOUR ni RÉINSTALLER CamAPS FX. Pour toute question, veuillez contacter le service client mylife-Diabetescare.',

    header_95:'',
    body_95:'',

    header_94:'Mise à jour Dexcom G7 (Ypsopump uniquement) 28/04/2026',
    body_94:'Pour CH uniquement - Nous approchons la compatibilité Dexcom G7 avec votre application CamAPS FX ! L\'intégration devrait être disponible en Suisse entre mi- et fin mai 2026. D\'autres informations suivront prochainement.',

    header_93:'Désactivation des versions iOS inférieures à 1.4(193) (Ypsopump uniquement) 22/04/2026',
    body_93:'Cher utilisateur de CamAPS FX, pour des raisons de cybersécurité, les VERSIONS INFÉRIEURES à 1.4(193) seront DÉSACTIVÉES le 30 avril. Veuillez vous assurer que votre application est MISE À JOUR vers la version 1.4(193) avant cette date. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_92:'Désactivation des anciens systèmes d\'exploitation 21/04/2026',
    body_92:'Pour des raisons de cybersécurité, à partir du 30 juin 2026, mylife CamAPS FX sera UNIQUEMENT pris en charge sur des téléphones compatibles avec le capteur exécutant les systèmes d’exploitation suivants : Android OS 13 et versions ultérieures, et Apple iOS 18 et versions ultérieures. Les utilisateurs de systèmes d’exploitation INFÉRIEURS à Android OS 13 ou Apple iOS 18 ne pourront PAS METTRE À JOUR ni RÉINSTALLER mylife CamAPS FX après cette date.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'Désactivation des versions iOS inférieures à 1.4(193) (Ypsopump uniquement) 16/03/2026',
    body_87:'Cher utilisateur de CamAPS FX, pour des raisons de cybersécurité, les VERSIONS INFÉRIEURES à 1.4(193) seront DÉSACTIVÉES le 31 mars. Veuillez vous assurer que votre application est MISE À JOUR vers la version 1.4(193) avant cette date. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Mise à jour de l\'application Android (Ypsopump uniquement) 02/02/2026',
    body_82:'Cher utilisateur de CamAPS FX, une NOUVELLE VERSION de l\'application sera disponible dans les prochains jours – 1.4(190). DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES de CamAPS FX dans le Google Play Store afin de choisir le moment de mise à jour qui vous convient. Pour des raisons de cybersécurité, les VERSIONS INFÉRIEURES à 1.4(190) seront ARRÊTÉES le 31 mars. Pour toute question, veuillez contacter le service client mylife-Diabetescare.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'Message de mylife-Diabetescare (uniquement YpsoPump) 17/12/2025',
    body_78:'Pour BE uniquement - À partir d\'aujourd\'hui, nous vous demandons de recharger votre mylife ' +
        'YpsoPump réservoir une fois. Cela permet d\'assurer la continuité du traitement, ' +
        'pour vous et pour les autres. Merci pour votre soutien.',

    header_77:'Message de mylife-Diabetescare (uniquement pour YpsoPump) 17/12/2025',
    body_77:'Pour FR uniquement - Vous pouvez effectuer un second remplissage de votre ' +
        'mylife YpsoPump Reservoir, dans les 7 jours suivant le premier remplissage. ' +
        'Consultez le mode d\'emploi ou demandez conseil à votre professionnel de santé pour en savoir plus.',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Message de mylife-Diabetescare (uniquement YpsoPump) 09/12/2025',
    body_74:'Vous pouvez effectuer un second remplissage de votre mylife YpsoPump Reservoir dans les 7 jours suivant le premier remplissage. En savoir plus sur la page Réservoir du site web mylife-diabetescare.',

    header_73:'Informations de sécurité importantes concernant votre capteur du système FreeStyle Libre 3 (Pour CH uniquement) 25/11/2025',
    body_73:'Abbott a identifié que certains capteurs du système FreeStyle Libre 3 peuvent afficher des lectures de glucose faussement basses. Rendez-vous sur',
    body_73_link_text:'www.FreeStyleCheck.com',
    body_73_end: ' pour vérifier si votre ou vos capteur(s) actuel(s) ou inutilisé(s) sont potentiellement concernés. Si vos lectures du capteur ne correspondent pas à vos symptômes ou à vos attentes, désactivez l\'Auto mode et utilisez un lecteur de glycémie pour prendre des décisions thérapeutiques. Si vous avez des questions ou devez signaler tout problème concernant votre capteur FreeStyle Libre 3, veuillez contacter le service clientèle d\'Abbott à 08 00 804 404. Le numéro de série du capteur actuel se trouve dans le menu de l\'application, sous Capteur.',
    body_73_link:'https://www.FreeStyleCheck.com',

    header_72:'Informations de sécurité importantes concernant votre capteur du système FreeStyle Libre 3 (Pour LU uniquement) 25/11/2025',
    body_72:'Abbott a identifié que certains capteurs du système FreeStyle Libre 3 peuvent afficher des lectures de glucose faussement basses. Rendez-vous sur',
    body_72_link_text:'www.FreeStyleCheck.com',
    body_72_end: ' pour vérifier si votre ou vos capteur(s) actuel(s) ou inutilisé(s) sont potentiellement concernés. Si vos lectures du capteur ne correspondent pas à vos symptômes ou à vos attentes, désactivez l\'Auto mode et utilisez un lecteur de glycémie pour prendre des décisions thérapeutiques. Si vous avez des questions ou devez signaler tout problème concernant votre capteur FreeStyle Libre 3, veuillez contacter le service clientèle d\'Abbott à 8002 54 87. Le numéro de série du capteur actuel se trouve dans le menu de l\'application, sous Capteur.',
    body_72_link:'https://www.FreeStyleCheck.com',

    header_71:'Informations de sécurité importantes concernant votre capteur du système FreeStyle Libre 3 (Pour FR uniquement) 25/11/2025',
    body_71:'Abbott a identifié que certains capteurs du système FreeStyle Libre 3 peuvent afficher des lectures de glucose faussement basses. Rendez-vous sur',
    body_71_link_text:'www.FreeStyleCheck.com',
    body_71_end: ' pour vérifier si votre ou vos capteur(s) actuel(s) ou inutilisé(s) sont potentiellement concernés. Si vos lectures du capteur ne correspondent pas à vos symptômes ou à vos attentes, désactivez l\'Auto mode et utilisez un lecteur de glycémie pour prendre des décisions thérapeutiques. Si vous avez des questions ou devez signaler tout problème concernant votre capteur FreeStyle Libre 3, veuillez contacter le service clientèle d\'Abbott à 0800 10 11 56. Le numéro de série du capteur actuel se trouve dans le menu de l\'application, sous Capteur.',
    body_71_link:'https://www.FreeStyleCheck.com',

    header_70:'Informations de sécurité importantes concernant votre capteur du système FreeStyle Libre 3 (Pour BE uniquement) 25/11/2025',
    body_70:'Abbott a identifié que certains capteurs du système FreeStyle Libre 3 peuvent afficher des lectures de glucose faussement basses. Rendez-vous sur',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' pour vérifier si votre ou vos capteur(s) actuel(s) ou inutilisé(s) sont potentiellement concernés. Si vos lectures du capteur ne correspondent pas à vos symptômes ou à vos attentes, désactivez l\'Auto mode et utilisez un lecteur de glycémie pour prendre des décisions thérapeutiques. Si vous avez des questions ou devez signaler tout problème concernant votre capteur FreeStyle Libre 3, veuillez contacter le service clientèle d\'Abbott à 0800 167 72. Le numéro de série du capteur actuel se trouve dans le menu de l\'application, sous Capteur.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'Mise à jour de l\'application iOS (uniquement YpsoPump) 25/11/2025',
    body_69:'Cher utilisateur de mylife CamAPS FX, une NOUVELLE VERSION de l\'application sera disponible dans les prochains jours. DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES DE CamAPS FX dans l\'App Store pour choisir votre moment de mise à jour préféré. Votre version actuelle sera DÉSACTIVÉE le 9 décembre 2025. Si vous avez des questions, veuillez contacter le service client de Ypsomed.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'INFORMATION DE SÉCURITÉ IMPORTANTE 28/10/2025',
    body_62:'Veuillez lire et confirmer que vous avez pris connaissance de l\'avis important',
    body_62_link_text:'N-0125',
    body_62_end: '. Accédez au menu de l\'application, sélectionnez Sécurité et lisez l\'avis.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+FR+final.pdf',

    header_61:'Mise à jour de l\'application iOS (Uniquement YpsoPump) 02/10/2025',
    body_61:'Pour un fonctionnement optimal de l\'application, veuillez METTRE À JOUR votre mylife CamAPS FX vers la DERNIÈRE VERSION (1.4(192)) via l\'App Store d\'Apple.',

    header_60:'',
    body_60:'',

    header_59:'Mise à jour de l\'application iOS (YpsoPump uniquement) 22/09/2025',
    body_59:'Cher utilisateur de mylife CamAPS FX, une NOUVELLE VERSION de l\'application sera disponible dans les prochains jours. DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES DE CamAPS FX dans l\'App Store pour choisir votre moment de mise à jour préféré. Une nouvelle version du manuel utilisateur sera disponible. Si vous avez des questions, veuillez contacter le service client de Ypsomed.',

    header_58:'Sortie iOS 26 (YpsoPump uniquement) 13/09/2025',
    body_58:'Apple va bientôt sortir iOS 26. Pour garantir une utilisation sans interruption de l\'application mylife CamAPS FX, veuillez consulter le site Web du fabricant du capteur pour vérifier la compatibilité entre le smartphone et le système d\'exploitation avant de mettre à jour votre iPhone vers iOS 26. Remarque : Les mises à jour automatiques peuvent être activées par défaut dans les paramètres de votre téléphone, veuillez les désactiver.',

    header_57:'Mise à jour de l\'application Android (uniquement YpsoPump) 26/08/2025',
    body_57:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les 2 à 3 jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Une nouvelle version du manuel utilisateur sera disponible. Si vous avez des questions, veuillez contacter le service client Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
	header_52:'',
    body_52:'',
	
	header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Fin des anciennes versions de l\'application 01/07/2025',
    body_49:'La version actuelle cessera de fonctionner le 1er août 2025. Veuillez mettre à jour votre application avec la dernière version disponible sur Google Play.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Pour des raisons de cybersécurité, à partir du 1er août2025, mylife CamAPS FX ne sera pris en charge que sur les téléphones compatibles avec les capteurs fonctionnant sous les systèmes d\'exploitation Android 12 et supérieurs. Les utilisateurs de systèmes d\'exploitation inférieurs à OS 12 ne pourront plus mettre à jour ou réinstaller mylife CamAPS FX après cette date.',

    header_47:'Version iOS (YpsoPump uniquement) 09/06/2025',
    body_47:'L\'application mylife CamAPS FX est désormais disponible pour iPhone! Pour plus d\'infomation, veuillez-vous rapprocher de votre prestataire ou votre équipe soignante.',

    header_46:'',
    body_46:'',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Pour garantir une utilisation ininterrompue de l\'application CamAPS FX, veuillez consulter le site Web du fabricant du capteur afin de vérifier la compatibilité avant de procéder à la mise à jour vers Android OS 16. Note: Les mises à jour automatiques pourraient être activées par défaut dans les paramètres de votre téléphone.',

    header_44:'Mise à jour du manuel de l\'utilisateur 20/05/2025',
    body_44:'Une version actualisée du manuel d\'utilisation est disponible.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Nouvelle mise à jour (18/03/2025)',
    body_40:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 48 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed.',
 
    header_39:'',
    body_39:'',

    header_38:'Arrêt de l\'ancienne version de l\'application (uniquement pour la pompe Dana)',
    body_38:'La version actuelle cessera de fonctionner le 7 février 2025. Veuillez mettre à jour votre application avec la dernière version disponible sur Amazon Appstore App.',

    header_37:'Interruption de l\'ancienne version de l\'application (uniquement pour Ypsopump)',
    body_37:'La version actuelle cessera de fonctionner le 7 février 2025. Mettez à jour votre application vers la dernière version disponible sur Google Play.',

    header_36:'une nouvelle version de l\'application 06/01/2025',
    body_36:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 48 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed. ',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Pour des raisons de cybersécurité, à partir du 1er janvier 2025, CamAPS FX ne sera pris en charge que sur les téléphones compatibles avec les capteurs fonctionnant sous les systèmes d\'exploitation Android 10 et supérieurs. Les utilisateurs de systèmes d\'exploitation inférieurs à OS 10 ne pourront plus mettre à jour ou réinstaller CamAPS FX après cette date. Rappel, le système n\'est pas encore compatible avec OS15.',
	
	header_34:'',
    body_34:'',
	
	header_33:'Avis de maintenance planifiée 05/12/2024',
    body_33:'Nous souhaitons vous informer qu\'une maintenance programmée du service cloud CamAPS FX aura lieu le 7 décembre à partir de 11h00 CET, pour une durée d\'environ trois heures. Pendant cette période, la fonctionnalité Companion sera temporairement indisponible. Nous vous prions de nous excuser pour la gêne occasionnée et vous remercions de votre compréhension.',
	
	header_32:'Mise à jour du manuel de l\'utilisateur 28/11/2024',
    body_32:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_31:'une nouvelle version de l\'application 17/11/2024',
    body_31:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 48 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed. ',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Pour des raisons de cybersécurité, à partir du 1er janvier 2025, CamAPS FX ne sera pris en charge que sur les téléphones compatibles avec les capteurs fonctionnant sous les systèmes d\'exploitation Android 10 et supérieurs. Les utilisateurs de systèmes d\'exploitation inférieurs à OS 10 ne pourront plus mettre à jour ou réinstaller CamAPS FX après cette date.',
	
	header_29:'une nouvelle version de l\'application 09/10/2024',
    body_29:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 48 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed. ',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Pour des raisons de cybersécurité, à partir du 1er janvier 2025, CamAPS FX ne sera pris en charge que sur les téléphones compatibles avec les capteurs fonctionnant sous les systèmes d\'exploitation Android 10 et supérieurs. Les utilisateurs de systèmes d\'exploitation inférieurs à OS 10 ne pourront plus mettre à jour ou réinstaller CamAPS FX après cette date.',
	
	header_27:'',
    body_27:'',
	
	header_26:'Mise à jour du manuel de l\'utilisateur 11/05/2024',
    body_26:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_25:'une nouvelle version de l\'application 05/05/2024',
    body_25:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 24 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed. ',
	
	header_24:'',
    body_24:'',
	
	header_23:'une nouvelle version de l\'application 24/04/2024',
    body_23:'Cher utilisateur de mylife CamAPS FX, une nouvelle version de l\'application sera disponible dans les prochaines 24 heures. Si vous souhaitez choisir le moment qui vous convient pour effectuer la mise à jour, vous pouvez désactiver la mise à jour automatique de mylife CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client d\'Ypsomed. ',

	header_22:'Mise à jour du manuel de l\'utilisateur 21/04/2024',
    body_22:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Mise à jour du manuel de l\'utilisateur 04/03/2024',
    body_16:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_15:'Mise à jour du manuel de l\'utilisateur 04/01/2024',
    body_15:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Rappel: Pour garantir une utilisation ininterrompue de l\'application mylife CamAPS FX, veuillez consulter le site Web du fabricant du capteur afin de vérifier la compatibilité avant de procéder à la mise à jour vers Android OS 14. Note: Les mises à jour automatiques pourraient être activées par défaut dans les paramètres de votre téléphone. mylife CamAPS FX avant de procéder à la mise à jour vers Android OS ',
	
	header_13:'INFORMATION DE SÉCURITÉ IMPORTANTE 14/11/2023',
    body_13:'INFORMATION DE SÉCURITÉ IMPORTANTE.',
    body_13_link_text:'Veuillez lire et confirmer que vous avez pris connaissance de l\'avis important',
    body_13_end: '. Accédez au menu de l\'application, sélectionnez Sécurité et lisez l\'avis.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Users+-+FR.pdf',

	header_12:'Mise à jour du manuel de l\'utilisateur 10/11/2023',
    body_12:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'Pour garantir une utilisation ininterrompue de l\'application mylife CamAPS FX, veuillez consulter le site Web du fabricant du capteur afin de vérifier la compatibilité avant de procéder à la mise à jour vers Android OS 14. Note: Les mises à jour automatiques pourraient être activées par défaut dans les paramètres de votre téléphone. Veuillez-vous assurer que vous utilisez la version 1.4(173) de l\'application mylife CamAPS FX avant de procéder à la mise à jour vers Android OS 14.',

	header_10:'INFORMATION DE SÉCURITÉ IMPORTANTE 15/08/2023',
    body_10:'INFORMATION DE SÉCURITÉ IMPORTANTE. Veuillez lire et confirmer que vous avez pris connaissance de l\'avis important. Accédez au menu de l\'application, sélectionnez Sécurité et lisez l\'avis.',
	
	header_9:'Mise à jour du manuel de l\'utilisateur 27/07/2023',
    body_9:'Une version actualisée du manuel d\'utilisation est disponible.',
	
	header_8:'',
    body_8:'',
	
	header_7:'Samsung de la série A 14/07/2023 ',
    body_7:'Les utilisateurs des modèles Samsung de la série A (c\'est-à-dire A53, A33) ont peut-être connu une perte de signal avec leur capteur CGM suite à la dernière mise à jour Samsung One UI 5.1. Samsung a identifié le problème et une solution est en cours de développement. Samsung prévoit de publier une mise à jour de One UI le 24 juillet (selon votre pays), qui résoudra le problème de perte de signal. Il est recommandé d\'installer la mise à jour dès qu\'elle sera disponible. Si vous n\'avez pas encore mis à jour vers One UI 5.1, nous vous recommandons d\'attendre la prochaine mise à jour Samsung One UI.',

    header_6:'',
    body_6:'',

    header_5:'',
    body_5:'',

    header_4:'Mise à jour du manuel de l\'utilisateur 27/05/2023',
    body_4:'Une version actualisée du manuel d\'utilisation est disponible.',

    header_3:'Alertes par SMS (Ypsopump uniquement) 11/05/2023',
    body_3:'Avec la prochaine mise à jour 1.4(171) mi-mai, vous pourrez activer jusqu\'à 5 followers SMS ET utiliser simultanément le mode Companion. Pour utiliser le mode Companion, le téléphone de l\'utilisateur doit avoir une connexion internet pour partager les données. Les utilisateurs doivent avoir une carte SIM pour permettre l\'envoi de SMS depuis leur téléphone. Si vous utilisez l\'une de ces options, nous vous conseillons de vérifier que votre forfait mobile inclut les SMS et/ou la couverture de données en fonction de l\'option que vous utilisez.',

    header_2:'Mise à jour sur la cybersécurité (Ypsopump uniquement) 24/04/2023',
    body_2:'Ne s\'applique pas aux utilisateurs de France. La sécurité de l\'application mylife CamAPS FX est importante pour nous. À partir de mi-mai, une mise à jour de cybersécurité imposée par Google Play Store sera en vigueur. À la suite de cette mise à jour, certains smartphones utilisés pourraient ne pas valider le test d\'intégrité de cybersécurité. Vous pouvez tester votre téléphone en amont, en accédant au menu d\'aide de l\'application et en effectuant une "vérification d\'intégrité". Si votre téléphone échoue à ce test, Essayez de désinstaller et réinstaller l\'application.',

    header_1:'Compatibilité avec Glooko 14/04/2023',
    body_1:'mylife CamAPS FX est maintenant compatible avec Glooko. Veuillez mettre à jour votre application mylife CamAPS FX. Connectez-vous à votre compte Diasend sur un navigateur Web et suivez le processus de mise à niveau car Diasend fusionne avec Glooko. Après avoir terminé avec succès, veuillez redémarrer votre téléphone pour envoyer automatiquement vos données à Glooko. Diasend sera disponible pour consulter les données historiques pour le reste de l\'année. Veuillez passer à Glooko avant le 14 juin 2023. Remarque : Si vous changez votre mot de passe pendant le processus de mise à niveau, vous devrez également mettre à jour le mot de passe dans le menu Partager de mylife CamAPS FX. Si vous habitez en France, la solution GlookoXT sera prête dans les prochaines semaines.',
};
